import { render } from "./new_request.vue?vue&type=template&id=54d212fa"
import script from "./new_request.vue?vue&type=script&lang=js"
export * from "./new_request.vue?vue&type=script&lang=js"

import "./new_request.vue?vue&type=style&index=0&id=54d212fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__